module.exports = __webpack_public_path__ + "Icon-asia.06a2a6e8acb628117f56894b27ceaa27.svg";